export type WheelState = {
  animate: boolean;
};

export const InitialWheelState = {
  animate: true,
};
